import React from 'react';
import { Redirect } from 'react-router';
import Auxi from '../../hoc/Auxi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPhoneSquareAlt, faVoicemail, faUserCog } from '@fortawesome/free-solid-svg-icons';
import { Navbar, Nav } from 'react-bootstrap';
import './Layout.css';

class CustomAppTabLayout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            performLogout: false,
            openVoiceMails: false,
            openCallParking: false,
            openUserSettings: false,
            openLandingPage: false,
            activeTab: this.props.fromPage, // Track the active tab
        };
    }

    setActiveTab = (tabName) => {
        this.setState({ activeTab: tabName });
    }

    backHandler = (evt) => {
        evt.preventDefault();
        this.setActiveTab('back');
        this.setState({ openLandingPage: true });
    }

    voiceHandler = (evt) => {
        evt.preventDefault();
        this.setActiveTab('voicemail');
        this.setState({ openVoiceMails: true });
    }

    callParkingHandler = (evt) => {
        evt.preventDefault();
        this.setActiveTab('callPark');
        this.setState({ openCallParking: true });
    }

    userSettingsHandler = (evt) => {
        evt.preventDefault();
        this.setActiveTab('userSettings');
        this.setState({ openUserSettings: true });
    }

    render() {
        let url = decodeURIComponent(window.location.href);
        url = url.substring(url.lastIndexOf("?username="), url.length);

        let redirect = null;
        const indexPath = "/custom_tab/index" + url;
        const voiceMailPath = "/custom_tab/voice_messages" + url;
        const vmailSettingsPath = "/custom_tab/vmail_settings" + url;
        const callParkingPath = "/custom_tab/call_parkings" + url;

        if (this.state.openLandingPage) {
            this.setState({ openLandingPage: false });
            redirect = <Redirect to={indexPath} />;
        }

        if (this.state.openVoiceMails) {
            this.setState({ openVoiceMails: false });
            redirect = <Redirect to={voiceMailPath} />;
        }

        if (this.state.openCallParking) {
            this.setState({ openCallParking: false });
            redirect = <Redirect to={callParkingPath} />;
        }

        if (this.state.openUserSettings) {
            this.setState({ openUserSettings: false });
            redirect = <Redirect to={vmailSettingsPath} />;
        }

        return (
            <Auxi>
                {redirect}
                <div className="app-layout">
                    <Navbar collapseOnSelect expand="lg" className="app-navbar" variant="light">
    
                        
                            {/* <Nav.Link
                                href="#"
                                onClick={this.callParkingHandler}
                                className={this.state.activeTab === 'callPark' ? 'active-tab' : ''}
                            >
                                <FontAwesomeIcon icon={faPhoneSquareAlt} /> Call Park
                            </Nav.Link> */}
                            <Nav.Link
                                href="#"
                                onClick={this.voiceHandler}
                                className={this.state.activeTab === 'voicemail' ? 'active-tab' : ''}
                            >
                                <FontAwesomeIcon icon={faVoicemail} /> Voicemail
                            </Nav.Link>
                            <Nav.Link
                                href="#"
                                onClick={this.userSettingsHandler}
                                className={this.state.activeTab === 'userSettings' ? 'active-tab' : ''}
                            >
                                <FontAwesomeIcon icon={faUserCog} /> User Settings
                            </Nav.Link>
                        
                    </Navbar>
                </div>
            </Auxi>
        );
    }
}

export default CustomAppTabLayout;
